import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { PlanCard } from "@/pages/particular-signup/select_plan/plans";
import EmbeddedCheckoutComponent from "@/pages/particular-signup/select_plan/EmbeddedCheckout";
import { useNavigate } from "react-router";
import { usePostHog } from "posthog-js/react";

import { BILLING_INTERVALS, getOwnerPlans } from "./owner-plans";
import BillingIntervalSelector from "./billing-interval-selector";

export default function SelectPlan({ selectedPlanId }) {
  const navigate = useNavigate();
  const posthog = usePostHog();
  const defaultPlan = selectedPlanId || "pro-enterprise";
  const [billingInterval, setBillingInterval] = useState(BILLING_INTERVALS.MONTHLY);
  const [showCheckout, setShowCheckout] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(defaultPlan);
  const ownerPlans = getOwnerPlans(billingInterval);
  const getSelectedPriceId = () => {
    const plan = ownerPlans.find((candidate) => candidate.idPlan === selectedPlan);
    return plan ? plan.priceId : null;
  };
  useEffect(() => {
    setSelectedPlan(selectedPlanId || "pro-enterprise");
  }, [selectedPlanId]);

  const handleBackToPlans = () => {
    setShowCheckout(false);
  };

  return (
    <>
      {showCheckout ? (
        <div className="w-full flex items-center justify-center">
          <EmbeddedCheckoutComponent
            key={`${selectedPlan}-${billingInterval}`}
            priceId={getSelectedPriceId()}
            onBack={handleBackToPlans}
          />
        </div>
      ) : (
        <div className="max-w-screen-2xl mx-auto px-4 sm:px-4 lg:px-16 py-10">
          <h2 className="text-2xl font-semibold mb-6 text-center">Elige un plan para comenzar</h2>
          <div className="flex justify-center mb-6">
            <BillingIntervalSelector value={billingInterval} onValueChange={setBillingInterval} />
          </div>
          <div className="grid gap-6 justify-items-center grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {ownerPlans.map((plan) => (
              <PlanCard
                key={plan.id}
                plan={plan}
                planType="owner"
                selectedPlan={selectedPlan}
                onSelectPlan={(e) => {
                  setSelectedPlan(e);
                  if (posthog) {
                    posthog.capture("Signup - Pro", {
                      step: 3,
                      stepName: "plan_selected",
                      plan: e,
                    });
                  }
                  if (e === "pro-gratis") {
                    navigate("/inicio");
                  } else {
                    setShowCheckout(true);
                  }
                }}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
}

SelectPlan.propTypes = {
  selectedPlanId: PropTypes.string,
};
